"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.c = exports.colors = void 0;
var colors = {
  black: '#000000',
  white: '#ffffff',
  grey: '#e3e3e3',
  lightgrey: '#f0f0f0',
  darkgrey: '#999999',
  red: '#ce171a',
  orange: '#FF7200',
  gold: '#BA935F',
  primary: {
    "default": '#000000',
    hover: '#292929'
  },
  secondary: {
    "default": '#53565A',
    hover: '#66696E'
  },
  tertiary: {
    "default": '#D6D6D6',
    hover: '#F0F0F0'
  },
  product: {
    "default": '#007DB5',
    hover: '#0272A9'
  },
  disabled: {
    "default": '#EBEBEB',
    color: '#6E6E6E'
  },
  forms: {
    darkgrey: '#444444',
    grey: '#bbbcbc',
    lightgrey: '#E7E7E7',
    green: '#2e8d4e',
    red: '#E5323A'
  }
};
exports.colors = colors;
var c = {
  blue: {
    a: '#007DB5',
    b: '#0272A9'
  },
  black: {
    a: '#000000',
    b: '#2D2926',
    c: '#1b1b1b'
  },
  grey: {
    a: '#444444',
    b: '#53565A',
    c: '#6E6E6E',
    d: '#BBBCBC',
    e: '#E7E7E7',
    f: '#EBEBEB',
    g: '#F5F5F5',
    h: '#D2D2D2'
  },
  white: {
    a: '#FFFFFF'
  },
  green: {
    a: '#2C8349'
  },
  red: {
    a: '#BF2E35',
    b: '#FF453A'
  },
  orange: {
    a: '#E65722',
    b: '#FFB005'
  },
  yellow: {
    a: '#B8860B'
  }
};
exports.c = c;